import { Outlet, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import Header from "./Header";
import { useEffect, useState } from "react";
import { sideBarShowReducer, sideBarShowReducerSmall, } from "app/reducers/layoutSlice";
import { UserInfoModel } from "app/model/ua/user-info";
import { getUserMenus } from "app/reducers/menuSlice";
import { getCommonCode } from "app/reducers/CodeSlice";
import { HashLink } from "react-router-hash-link";
import AuthProtector from "app/guard/AuthProtector";

export default function Layout() {
  const spinner = useAppSelector((state) => state.spinner.loading);
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [width,] = useState(window.innerWidth);
  const [isMainDashboard, setIsMainDashboard] = useState<boolean>(false);

  useEffect(() => {
    if (width > 768 && width < 1200) {
      dispatch(sideBarShowReducer(false));
    } else if (width < 768) {
      dispatch(sideBarShowReducerSmall(true));
    }

    const resizeListener = () => {
      const innerWidth = window.innerWidth;
      if (innerWidth < 768) {
        dispatch(sideBarShowReducer(true));
      } else if (innerWidth < 1200) {
        dispatch(sideBarShowReducer(false));
      } else {
        dispatch(sideBarShowReducer(true));
      }

      if (innerWidth < 768) {
        dispatch(sideBarShowReducerSmall(true));
      } else {
        dispatch(sideBarShowReducerSmall(false));
      }
    };

    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  useEffect(() => {
    dispatch(getCommonCode());
  }, []);

  useEffect(() => {
    if (userInfo && userInfo.userId) {
      dispatch(getUserMenus(userInfo.userId));
    }
  }, [userInfo]);

  useEffect(() => {
    setIsMainDashboard((location.pathname === '/dbAdmin' || location.pathname === '/dbUser'));
  }, [location.pathname]);

  return (
    <>
      {spinner && (
        <div className="progress-spinner text-center">
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div id="skipArea">
        <HashLink to="#contents">본문으로 바로가기</HashLink>
      </div>

      <div id="wrap">
        <AuthProtector>
          <Header />
          <div id="container">
            <div id="sub_container" className={isMainDashboard ? 'main-dashboard' : ''}>
              <div id="contents">
                <Outlet></Outlet>
              </div>
            </div>
          </div>
        </AuthProtector>
      </div>
    </>
  );
}
